import { UiUtils } from "../common/uiUtils";

export interface ISdUiApi {
    showViewCube(show: boolean);
    showToolbars(show: boolean);
}

export class SdUiApi implements ISdUiApi {
    #forgeViewer: Autodesk.Viewing.GuiViewer3D;
    errorMessage: string;

    #cubeExtension = "Autodesk.ViewCubeUi";
    #toolbarContainerName = "guiviewer3d-toolbar";

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        this.#forgeViewer = viewer;
        this.errorMessage = "";
    }

    showViewCube(show: boolean = true) {
        const cube = this.#getViewCube();
        if (cube != null) {
            cube.setVisible(show);
        } else {
            // The view cube is not available yet, wait for it.
            const onViewCubeLoaded = ({ extensionId }) => {
                if (extensionId === this.#cubeExtension) {
                    this.#getViewCube().setVisible(show);
                    this.#forgeViewer.removeEventListener(Autodesk.Viewing.EXTENSION_LOADED_EVENT, onViewCubeLoaded);
                }
            }

            this.#forgeViewer.addEventListener(Autodesk.Viewing.EXTENSION_LOADED_EVENT, onViewCubeLoaded);
        }
    }

    showToolbars(show: boolean = true) {
        if (show)
            UiUtils.setUiElementStyle(this.#toolbarContainerName, "display", "block", "important");
        else
            UiUtils.setUiElementStyle(this.#toolbarContainerName, "display", "none");
    }

    #getViewCube(): any {
        return this.#forgeViewer.getExtension(this.#cubeExtension);
}
}